import * as React from "react";
import { CircularProgress, styled } from '@mui/material';

const ProgressContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

const _Progress = function (props: {
  marginTop?: number,
}) {
  const marginTop = props.marginTop ? props.marginTop : 0;
  return (
    <ProgressContainer style={{marginTop: marginTop}}><CircularProgress/></ProgressContainer>
  );
};

export default _Progress;
export const Progress = _Progress;
